// GlobalConfigContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react"

// Define types for the context value
interface GlobalConfigContextType {
  isSidebarOpen: boolean
  toggleSidebar: () => void
  sidebarClose: () => void
  sidebarOpen: () => void
  toggleSubMenu: (title: string | null) => void
  subMenu: string | null
}

// Define types for the provider props
interface GlobalConfigProviderProps {
  children: ReactNode
}

// Create the context with an initial value of undefined
const GlobalConfigContext = createContext<GlobalConfigContextType | undefined>(undefined)

export const GlobalConfigProvider: React.FC<GlobalConfigProviderProps> = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true)
  const [subMenu, setSubMenu] = useState<string | null>(null)

  const toggleSidebar = () => {
    if (isSidebarOpen) toggleSubMenu(null)
    setSidebarOpen((prev) => !prev)
  }
  const sidebarClose = () => {
    toggleSubMenu(null)
    setSidebarOpen(false)
  }
  const sidebarOpen = () => setSidebarOpen(true)

  const toggleSubMenu = (title: string | null) => setSubMenu(title)
  return (
    <GlobalConfigContext.Provider
      value={{ isSidebarOpen, toggleSidebar, sidebarClose, sidebarOpen, toggleSubMenu, subMenu }}
    >
      {children}
    </GlobalConfigContext.Provider>
  )
}

// Custom hook to use the GlobalConfigContext
export const useGlobalConfig = (): GlobalConfigContextType => {
  const context = useContext(GlobalConfigContext)
  if (!context) {
    throw new Error("useGlobalConfig must be used within a GlobalConfigProvider")
  }
  return context
}
